export const LINKEDIN_PREFIX = 'Linkedin.com/';
export const INSTAGRAM_PREFIX = 'Instagram.com/';
export const X_PREFIX = 'X.com/';
export const TIKTOK_PREFIX = 'Tiktok.com/';
export const META_PIXEL_ID = '1071125111973558';
export const STARTHUB_PIXEL_ID = 'shpx_4ymnuolm40dv6';
export const STARTHUB_PIXEL_ENDPOINT = 'https://marketingos.starthub.academy/api/pixel';
export const STARTHUB_PIXEL_HOSTS: readonly string[] = [
  'starthub.academy',
  'www.starthub.academy',
  'founders.starthub.academy',
];
